export { default } from './AccordionDetails';
export { default as accordionDetailsClasses } from './accordionDetailsClasses';
export * from './accordionDetailsClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/AccordionDetails/index.js
// module id = 791
// module chunks = 22